import _ from "lodash";

import {
  OBTENER_RESULTADO_DETALLE,
  ERROR_OBTENER_RESULTADO_DETALLE,
  OBTENER_VALIDACION,
  ERROR_OBTENER_VALIDACION,
  OBTENER_ARCHIVOS_DETALLE,
  ERROR_OBTENER_ARCHIVOS_DETALLE,
  OBTENER_ARCHIVOS_DETALLE_PDF,
  ERROR_OBTENER_ARCHIVOS_DETALLE_PDF,
} from "../../types";
var CryptoJS = require("crypto-js");

export default (state, action) => {
  switch (action.type) {
    case OBTENER_RESULTADO_DETALLE:
      let dataetiquetas = action.payload.map((x) => x["medicion"]);
      let datavalores = action.payload.map((x) => x["valorPorcentaje"]);
      let row = _.head(action.payload);
      let estudios = _.uniqBy(action.payload, "estudio");
      //let etiquetas = _.pullAllBy(data,[{'medicion': ''}], 'medicion').map(x => x['medicion']);
      localStorage.removeItem("id");
      localStorage.setItem("id", row.transaccionId);
      return {
        ...state,
        resultadoMedico: action.payload,
        id: row.transaccionId,
        paciente: row.paciente,
        medico: row.medico,
        fecha: row.fecha,
        fechaValidacion: row.FechaValidacion,
        fechaNacimiento: row.fechaNacimiento,
        sucursalNombre: row.sucursalNombre,
        sucursalDireccion: row.sucursalDireccion,
        institucion: row.institucion,
        sexo: row.sexo,
        edad: row.edad,
        fechaImpresion: row.fecha_impresion,
        folio: row.folio,
        muestra: row.muestra,
        estudios: estudios,
        qr: row.qr,
        QRProveedor: row.QRProveedor,
        nombreTipoOrden: row.nombreTipoOrden,
        resultadoInterpretacion: row.resultadoInterpretacion,
        dataGrafica: {
          labels: _.compact(dataetiquetas),
          datasets: [
            {
              label: "Valor",
              fill: false,
              lineTension: 0.1,
              backgroundColor: "rgba(75,192,192,0.4)",
              borderColor: "rgba(75,192,192,1)",
              borderCapStyle: "butt",
              borderDash: [],
              borderDashOffset: 0.0,
              borderJoinStyle: "miter",
              pointBorderColor: "rgba(75,192,192,1)",
              pointBackgroundColor: "#fff",
              pointBorderWidth: 1,
              pointHoverRadius: 5,
              pointHoverBackgroundColor: "rgba(75,192,192,1)",
              pointHoverBorderColor: "rgba(220,220,220,1)",
              pointHoverBorderWidth: 2,
              pointRadius: 1,
              pointHitRadius: 10,
              data: _.pull(datavalores, null),
            },
          ],
        },
        optionsGrafica: {
          responsive: true,
          title: {
            display: true,
            text: "Gráfica de resultados",
          },
          legend: {
            display: false,
          },
          annotation: {
            annotations: [
              {
                type: "line",
                mode: "horizontal",
                scaleID: "y-axis-0",
                value: 100,
                borderColor: "red",
                borderWidth: 1,
              },
              {
                type: "line",
                mode: "horizontal",
                scaleID: "y-axis-0",
                value: 0,
                borderColor: "red",
                borderWidth: 1,
              },
            ],
          },
        },
        metodo: row.metodo,
      };
    case ERROR_OBTENER_RESULTADO_DETALLE:
      localStorage.removeItem("id");
      return {
        ...state,
        id: 0,
        resultadoMedico: [],
      };
    case OBTENER_VALIDACION:
      return {
        ...state,
        validacion: action.payload,
      };
    case ERROR_OBTENER_VALIDACION:
      return {
        ...state,
        validacion: null,
      };
    case OBTENER_ARCHIVOS_DETALLE:
      return {
        ...state,
        archivosDigitales: action.payload,
      };
    case ERROR_OBTENER_ARCHIVOS_DETALLE:
      return {
        ...state,
        archivosDigitales: null,
      };
    case OBTENER_ARCHIVOS_DETALLE_PDF:
      return {
        ...state,
        archivosDigitalesPDF: action.payload,
      };
    case ERROR_OBTENER_ARCHIVOS_DETALLE_PDF:
      return {
        ...state,
        archivosDigitalesPDF: null,
      };
    default:
      return state;
  }
};
